/**
 * Copied from https://gist.github.com/alirezamirian/b6cc3d5bc421d6e5338c002acde5e5bc
 */

/* eslint-disable */

(function () {

  'use strict';

  /**
   * This monkey-patch for the dropdownService enables to nest dropdowns.
   * Issue: https://github.com/angular-ui/bootstrap/issues/2421
   * PR:    https://github.com/angular-ui/bootstrap/pull/3776
   */

  angular.module('nested-ui-bootstrap-dropdown', ['ui.bootstrap.dropdown'])
      .decorator('uibDropdownService', dropdownServiceDecorator)
      .service('uibNestedDropdownService', nestedDropdownService);

  function dropdownServiceDecorator(uibNestedDropdownService) {
      return uibNestedDropdownService;
  }

  dropdownServiceDecorator.$inject = ['uibNestedDropdownService'];

  function nestedDropdownService($document, $rootScope, $$multiMap) {
      var openScopes = [];
      var openedContainers = $$multiMap.createNew();

      this.isOnlyOpen = function(dropdownScope, appendTo) {
        var openedDropdowns = openedContainers.get(appendTo);
        if (openedDropdowns) {
          var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
            if (dropdown.scope === dropdownScope) {
              return dropdown;
            }

            return toClose;
          }, {});
          if (openDropdown) {
            return openedDropdowns.length === 1;
          }
        }

        return false;
      };

      this.open = function (dropdownScope) {
          var upperScope = getUpperScope();

          if (!upperScope) {
              $document.bind('click', closeDropdown);
              $document.bind('keydown', escapeKeyBind);
          }

          while (upperScope && upperScope !== dropdownScope) {
              // contained dropdown, do not close dropdown
              if (upperScope.getDropdownElement()[0].contains(dropdownScope.getElement()[0])) {
                  break;
              }

              openScopes.pop().isOpen = false;
              upperScope = getUpperScope();
          }

          openScopes.push(dropdownScope);
      };

      this.close = function (dropdownScope) {

          if (openScopes.indexOf(dropdownScope) > -1) {
              var upperScope = getUpperScope();
              while (upperScope) {
                  openScopes.pop().isOpen = false;
                  if (upperScope === dropdownScope) {
                      break;
                  }
              }
          }

          if (!getUpperScope()) {
              $document.unbind('click', closeDropdown);
              $document.unbind('keydown', escapeKeyBind);
          }
      };

      this.keybindFilter = function(evt) {
        const openScope = getUpperScope();

        if (!openScope) {
          // see this.close as ESC could have been pressed which kills the scope so we can not proceed
          return;
        }

        var dropdownElement = openScope.getDropdownElement();
        var toggleElement = openScope.getToggleElement();
        var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
        var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
        if (evt.which === 27) {
          evt.stopPropagation();
          openScope.focusToggleElement();
          closeDropdown();
        } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
          evt.preventDefault();
          evt.stopPropagation();
          openScope.focusDropdownEntry(evt.which);
        }
      };

      var getUpperScope = function () {
          if (openScopes.length === 0) {
              return null;
          }

          return openScopes[openScopes.length - 1];
      };

      var closeDropdown = function (evt) {
          if (evt.target.id != '_nci_') {
              var upperScope = getUpperScope();
              while (upperScope) {

                  // This method may still be called during the same mouse event that
                  // unbound this event handler. So check upperScope before proceeding.
                  if (!upperScope) { break; }

                  if (evt && upperScope.getAutoClose() === 'disabled') { break; }

                  var toggleElement = upperScope.getToggleElement();
                  if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
                      break;
                  }

                  var $element = upperScope.getElement();

                  // https://github.com/angular-ui/bootstrap/commit/cc66a0687208b2cf41eecf92a922a6e0f92f2708
                  var dropdownElement = upperScope.getDropdownElement();
                  if (evt && upperScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
                      break;
                  }

                  upperScope.isOpen = false;
                  openScopes.pop();

                  if (!$rootScope.$$phase) {
                      upperScope.$apply();
                  }

                  // just close upper dropdown if ESC was pressed
                  if (angular.isUndefined(evt)) {
                      break;
                  }

                  upperScope = getUpperScope();
              }
          }
      };

      var escapeKeyBind = function (evt) {
          if (evt.which === 27) {
              getUpperScope().focusToggleElement();
              closeDropdown();
          }
      };
  }

  nestedDropdownService.$inject = ['$document', '$rootScope', '$$multiMap'];

})();